module.exports = __webpack_public_path__ + "img/icon_entrevista_hover.e0a4aa09.svg";